// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.Entity.--created { background-color: var(--created)\n}\n.Entity.--updated { background-color: var(--updated)\n}\n.Entity.--deleted {\n    pointer-events: none;\n    opacity: .5;\n}\n", ""]);
// Exports
module.exports = exports;
